




















































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component({
  components: {}
})
export default class extends Mixins(MyList) {
  dispatchType = "wechat/fans";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    {
      title: "类型",
      scopedSlots: { customRender: "mp_type" }
    },
    { title: "appid", dataIndex: "appid" },
    { title: "昵称", dataIndex: "nickname" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "openid", dataIndex: "openid" },
    { title: "unionid", dataIndex: "unionid" },
    { title: "性别", scopedSlots: { customRender: "sex" } },
    { title: "国别省份城市", scopedSlots: { customRender: "country" } },
    { title: "是否关注", scopedSlots: { customRender: "is_subscribe" } },
    { title: "关注时间", dataIndex: "subscribed_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
